export const VERSION_DEPRECATION = 'VERSION_DEPRECATION';
export const ACQUIRE_EXISTING_VERSION_MESSAGE = 'ACQUIRE_EXISTING_VERSION_MESSAGE';
export const ACQUIRE_EXISTING_VERSION_ACK_MESSAGE = 'ACQUIRE_EXISTING_VERSION_ACK_MESSAGE';
export function isAquireExistingVersionMessage(message) {
  return message && message.type === ACQUIRE_EXISTING_VERSION_MESSAGE;
}
export function isVersionDeprecationMessage(message) {
  return message && message.type === VERSION_DEPRECATION;
}